export enum CardView {
  Tiled='tiled',
  List='list',
  ShortList='shortList',
}

export enum SelectedViewType {
  Courses='coursesView',
  Lessons='lessonsView',
  Webinars='webinarsView',
  Tasks='tasksView',
}

export interface Views {
  sidebarView: null,
  coursesView: CardView,
  lessonsView: CardView,
  webinarsView: CardView,
  tasksView: CardView,
}

export const defaultViews: Views = {
  sidebarView: null,
  coursesView: CardView.Tiled,
  lessonsView: CardView.Tiled,
  webinarsView: CardView.Tiled,
  tasksView: CardView.Tiled,
};

/**
 * The hook return saved views from local storage, or default views
 * @return {void}
 */
export default function useSelectedView() {
  const views = localStorage.getItem('selectedViews');

  if (views) {
    return JSON.parse(views)
  }

  localStorage.setItem('selectedViews', JSON.stringify(defaultViews))

  return defaultViews;
}

/**
 * The hook return saved views from local storage, or default views
 * @return {void}
 */
export function setSelectedView(
  key: SelectedViewType,
  value: CardView
) {
  const views = localStorage.getItem('selectedViews');
  const parsed = views && JSON.parse(views);

  let result;

  if (parsed) {
    result = {
      ...parsed,
      [key]: value,
    }
  }
  else {
    result = {
      ...defaultViews,
      [key]: value,
    }
  }

  localStorage.setItem('selectedViews', JSON.stringify(result))
}
